<button mat-icon-button [matTooltip]="tooltip | translate" [disabled]="disabled" (click)="emitClick($event)">
	<mat-icon color="primary" class="icon-size-8" svgIcon="mat_solid:add_circle"></mat-icon>
</button>